// extracted by mini-css-extract-plugin
export default {"login":"Input_login__lSZhw","control":"Input_control__49qTm","invalid":"Input_invalid__otMIx","actions":"Input_actions__UAKYP"};